import React from "react"
import Link from "components/Link"
import { APACHE_SUPERSET_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function BuilderFirstSection() {
  const { getAsset } = usePageAssets()
  const supersetLogo = getAsset("home-superset-logo-svg")
  const background1 = getAsset("home-builder-first-item-1-bg")
  const background2 = getAsset("home-builder-first-item-2-bg")
  const background3 = getAsset("home-builder-first-item-3-bg")
  return (
    <Container section>
      <Heading
        label="Builder First"
        title="Trust the experts"
        subtitle={
          <div>
            Preset was founded by the original creator of{" "}
            <Link className="font-bold text-lush" href={APACHE_SUPERSET_URL}>
              Apache Superset™
            </Link>
            . Our team of experts contributes over 75% of all commits to the
            open-source software project.
          </div>
        }
        decoration="line"
      />
      <div className="mt-12 grid grid-cols-1 gap-y-4 lg:grid-cols-3 lg:gap-x-5 xl:gap-x-20">
        <Item
          bgImage={background1}
          content={
            <Image className="mx-auto max-w-[280px]" src={supersetLogo} />
          }
          linkText="Why the future of BI is open source"
          linkUrl="https://preset.io/blog/future-of-business-intelligence/"
          trackClick="Why the future of BI is open source (cta)_Home"
        />
        <Item
          bgImage={background2}
          content="Dataset-centric visualization for fast-moving data teams"
          linkText="Learn more about datasets"
          linkUrl="https://preset.io/blog/dataset-centric-visualization/"
          trackClick="Learn more about datasets (cta)_Home"
        />
        <Item
          bgImage={background3}
          content="Scaling Superset for builders and developers"
          linkText="Managing Superset assets as code"
          linkUrl="https://preset.io/blog/version-control-superset-charts-dashboards-superset/"
          trackClick="Managing Superset assets as code (cta)_Home"
        />
      </div>
    </Container>
  )
}

function Item({ bgImage, content, linkText, linkUrl, trackClick }) {
  return (
    <div className="safari-overflow-fix relative overflow-hidden rounded-1x pb-8 pt-14">
      <div className="absolute left-0 top-0 h-full w-full">
        <Image className="h-full w-full" src={bgImage} />
      </div>
      <div className="relative z-10 flex h-full flex-col justify-between">
        <div className="flex flex-1 items-center justify-center px-5 text-center text-2xl font-bold text-white sm:px-10">
          {content}
        </div>
        <div className="px-5 text-center">
          <Button
            href={linkUrl}
            className="mt-6"
            color="green"
            size="small"
            trackClick={trackClick}
            dark
          >
            {linkText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default BuilderFirstSection
